import * as actions from 'actions';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.COMMENTS_RECEIVED: { // We are getting new comments
      if(action.isForLiveList) {
        const unseenIds = action.result.commentsIds.filter(commentId => !state.includes(commentId));

        return [
          ...unseenIds,
          ...state
        ];
      }

      return state;
    }

    case actions.COMMENTS_FETCH_SUCCESS: { // We are getting older comments
      if(action.isForLiveList) {
        return [
          ...state,
          ...action.result.commentsIds
        ];
      }

      return state;
    }

    case actions.COMMENTS_RESET_LIVE_LIST:
      return [];

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/live/list/reducer.js
 **/